// Native selects can match :focus-visible after a tap. Track the actual input
// instead, without blurring controls or interrupting their native pickers.
export function installInputFeedback(doc) {
  let pointerFocus = false;
  const focused = new Set(), hovered = new Set(), shadowRoots = new Set();
  const clear = (elements, attribute) => {
    for (const element of elements) element.removeAttribute(attribute);
    elements.clear();
  };
  const mark = (elements, attribute, event) => {
    for (const element of elements) if (!element.isConnected) elements.delete(element);
    for (const element of event.composedPath()) {
      if (element.nodeType !== 1) continue;
      element.setAttribute(attribute, ''); elements.add(element);
    }
  };
  const observeShadowRoots = event => {
    for (const root of event.composedPath()) {
      if (root.nodeType !== 11 || !root.host || shadowRoots.has(root)) continue;
      // Focus moves within one shadow root do not reach the document.
      root.addEventListener('focusin', onFocus, true); shadowRoots.add(root);
    }
  };
  const onPointerDown = event => {
    pointerFocus = true;
    observeShadowRoots(event);
    mark(focused, 'data-pointer-focus', event);
    clear(hovered, 'data-touch-hover');
    if (event.pointerType === 'touch') mark(hovered, 'data-touch-hover', event);
  };
  const onFocus = event => {
    observeShadowRoots(event);
    if (pointerFocus) mark(focused, 'data-pointer-focus', event);
  };
  const onKey = event => {
    // Typing on a phone's virtual keyboard must not turn touch focus rings on.
    if (event.altKey || event.ctrlKey || event.metaKey || !['Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) return;
    pointerFocus = false; clear(focused, 'data-pointer-focus');
  };
  const onPointerMove = event => { if (event.pointerType === 'mouse') clear(hovered, 'data-touch-hover'); };
  const listeners = { pointerdown: onPointerDown, focusin: onFocus, keydown: onKey, pointermove: onPointerMove };
  for (const [type, listener] of Object.entries(listeners)) doc.addEventListener(type, listener, true);
  return () => {
    for (const [type, listener] of Object.entries(listeners)) doc.removeEventListener(type, listener, true);
    for (const root of shadowRoots) root.removeEventListener('focusin', onFocus, true);
    shadowRoots.clear();
    clear(focused, 'data-pointer-focus'); clear(hovered, 'data-touch-hover');
  };
}
